var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3409_4543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 7.5H19.5V2.8125C19.5 1.26169 18.2383 0 16.6875 0H7.3125C5.76169 0 4.5 1.26169 4.5 2.8125V7.5H3.5625C2.01169 7.5 0.75 8.76169 0.75 10.3125V24H23.25V10.3125C23.25 8.76169 21.9883 7.5 20.4375 7.5ZM4.5 22.125H2.625V10.3125C2.625 9.79556 3.04556 9.375 3.5625 9.375H4.5V22.125ZM13.875 22.125H10.125V20.625H13.875V22.125ZM17.625 22.125H15.75V18.75H8.25V22.125H6.375V2.8125C6.375 2.29556 6.79556 1.875 7.3125 1.875H16.6875C17.2044 1.875 17.625 2.29556 17.625 2.8125V22.125ZM21.375 22.125H19.5V9.375H20.4375C20.9544 9.375 21.375 9.79556 21.375 10.3125V22.125ZM8.25 5.625H15.75V3.75H8.25V5.625ZM8.25 9.375H15.75V7.5H8.25V9.375ZM8.25 13.125H15.75V11.25H8.25V13.125ZM8.25 16.875H15.75V15H8.25V16.875Z",
    fill: "#BABABA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3409_4543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.b95ac269fa516a7fec8b81085ce823ac.svg";
export { ForwardRef as ReactComponent };